<template>
    <tw-row class="tw-row-edit">
        <template v-for="column in columns" :key="column.field_name">
            <!-- 偏移（用偏移量控制换行） -->
            <tw-col v-if="column.col_xs_offset || column.col_sm_offset || column.col_md_offset || column.col_lg_offset || column.col_xl_offset" 
                class="tw-row-edit-offset" style="height:41px"
                :xs_span="column.col_xs_offset || 0"
                :sm_span="column.col_sm_offset || 0"
                :md_span="column.col_md_offset || 0"
                :lg_span="column.col_lg_offset || 0"
                :xl_span="column.col_xl_offset || 0">
                <div></div>
            </tw-col>
            <!-- 标题 -->
            <tw-col class="tw-row-edit-label" style="overflow: hidden; text-overflow:ellipsis; white-space: nowrap; font-weight: bold;color: #909399;font-size: 12px;
            white-space:nowrap;text-align:right;padding-right: 10px;height: 41px;line-height: 41px;overflow: hidden;"
                :xs_span="column.col_xs_label || 4" 
                :sm_span="column.col_sm_label || 4" 
                :md_span="column.col_md_label || 4" 
                :lg_span="column.col_lg_label || 2" 
                :xl_span="column.col_xl_label || 2">
                {{column.caption}}
            </tw-col>
            <!-- 内容 -->
            <tw-col class="tw-row-edit-content" style="padding-right:10px;height:41px"
                :xs_span="column.col_xs_input || 20" 
                :sm_span="column.col_sm_input || 20" 
                :md_span="column.col_md_input || 8" 
                :lg_span="column.col_lg_input || 6" 
                :xl_span="column.col_xl_input || 4">
                <tw-cell-edit style="width:100%; height:41px; line-height:41px;" :column="column" v-model="current[column.field_name]"></tw-cell-edit>
            </tw-col>
        </template>
    </tw-row>
</template>

<script>
import { computed } from 'vue'

export default {
    name: 'tw-row-edit',
    setup(props) {
        const columns = computed(() => {
            return props?.data_source?.columns?.filter(el => {
                let visible = true
                // 需要注意如果无 visible 时也要显示，只有等于 False 时才不显示
                if (el.visible === false) {
                    visible = false
                } else {
                    // 如果指定分组，则只显示该分组的字段
                    if (props.group_name) {
                        visible = el.group_name === props.group_name
                    }
                }

                return visible
            }) || []
        })

        const current = computed(() => {
            return props.data_source.current || {}
        })

        return {
            columns,
            current
        }
    },
    props: {
        data_source: {
            type: Object,
            default: function() {
                return {}
            }
        },
        group_name: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
.tw-row-edit {
    padding: 5px;
}

.tw-row-edit-offset {
    height:28px;
}

.tw-row-edit-label {
    font-weight: bold;
    color: #909399;
    font-size: 12px;

    /* 标题右对齐 */
    white-space:nowrap;
    text-align:right;
    padding-right: 5px;

    /* 标题垂直居中 */
    height: 28px;
    line-height: 28px;
    overflow: hidden;
}

.tw-row-edit-content {
    height:28px;
    margin-bottom: 5px;
}
.tw-row-edit:last-child {
    padding-bottom: 0px;
}

</style>